import React from 'react';
import XMLPreview from './XMLPreview';
import { getPreviewTransformation } from '../../services/TransformationsService';
import { Credentials } from '../../services/ApiType';

interface Props {
  url: string;
  xslt: string;
  credentials?: Credentials;
}

function XMLTransformationPreview({ url, xslt, credentials }: Readonly<Props>) {
  const fetchXml = () => getPreviewTransformation(
    url,
    { xslt, credentials },
  );

  return (
    <XMLPreview
      header="Transformation preview"
      errorMessage="Invalid XSLT transformation."
      fetchXml={fetchXml}
    />
  );
}

export default XMLTransformationPreview;
